export const PATIENT_PORTAL_SYSTEM_IDS = {
  MY_HEALTH: 'myhealth',
  AMPLAR: 'amplar',
} as const;

export type PatientPortalSystemOptions =
  (typeof PATIENT_PORTAL_SYSTEM_IDS)[keyof typeof PATIENT_PORTAL_SYSTEM_IDS];

export const PATIENT_PORTAL_SYSTEM_UUIDS = {
  myhealth: '11111111-1111-1111-1111-111111111111',
  amplar: '22222222-2222-2222-2222-222222222222',
} satisfies Record<PatientPortalSystemOptions, string>;

export const CONTAINER_BACKGROUND_COLOR = {
  myhealth: '$surfaceBackgroundSecondary',
  amplar: '$surfaceBackgroundPrimary',
} satisfies Record<PatientPortalSystemOptions, string>;
